import React, { Fragment, PureComponent } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'

import { localize } from 'helpers/translator'
import NavigationMenuList from 'components/navigation_menu_list/navigation_menu_list'
import navigationMenuContentTypes from 'helpers/enums/navigationMenuContentTypes'
import UpgradeIcon from 'assets/views/navigation_menu/main/upgrade.svg'
import navigationMenuMainItemTypes from 'helpers/enums/navigationMenuMainItemTypes'
import { BaseButton } from 'components/button'
import Avatar from 'components/avatar/avatar'
import Isvg from 'react-inlinesvg'

import NotificationPreferencesIcon from 'assets/views/navigation_menu/main/notification_preferences_icon.svg'
import HelpIcon from 'assets/views/navigation_menu/main/help_icon.svg'
import CameraIcon from 'assets/views/navigation_menu/main/camera.svg'
import SettingsIcon from 'assets/views/navigation_menu/main/settings_icon.svg'
import ManageIcon from 'assets/views/navigation_menu/main/manage_icon.svg'

import getIconByBadgeProduct from 'helpers/getIconByBadgeProduct'
import styles from './view.scss'

class NavigationMenuMain extends PureComponent {

	constructor(props) {
		super(props)

		this.items = [
			{
				id: navigationMenuMainItemTypes.ACCOUNT,
				icon: getIconByBadgeProduct(this.props.userBadge),
				label: localize('navigationMenu_account_label'),
				isHighlighted: true,
				isExtended: false,
			},
			{
				id: navigationMenuMainItemTypes.UPGRADE,
				icon: UpgradeIcon,
				label: localize('navigationMenu_upgrade_label2'),
				isHighlighted: false,
				isExtended: false,
			},
			{
				id: navigationMenuMainItemTypes.SETTINGS,
				icon: SettingsIcon,
				label: localize('navigationMenu_settings_label2'),
				isHighlighted: false,
				isExtended: false,
			},
			{
				id: navigationMenuMainItemTypes.MANAGE,
				icon: ManageIcon,
				label: localize('navigationMenu_manage_label'),
				isHighlighted: false,
				isExtended: false,
			},
			{
				id: navigationMenuMainItemTypes.NOTIFICATION_PREFERENCES,
				icon: NotificationPreferencesIcon,
				label: localize('navigationMenu_notificationPreferences_label'),
				isHighlighted: false,
				isExtended: this.props.shouldShowNotificationPreferencesView,
			},
			{
				id: navigationMenuMainItemTypes.HELP,
				icon: HelpIcon,
				label: localize('navigationMenu_help_label2'),
				isHighlighted: false,
				isExtended: true,
			},
		].filter(item =>
			item.id !== navigationMenuMainItemTypes.UPGRADE ||
			this.props.shouldShowUpgradeButton)
			.filter(item =>
				item.id !== navigationMenuMainItemTypes.MANAGE ||
				this.props.shouldShowManageButton)
	}

	handleNotificationPreferencesSelected = () => {
		if (this.props.shouldShowNotificationPreferencesView) {
			this.props.navigateTo(
				navigationMenuContentTypes.NOTIFICATION_PREFERENCES,
			)
		} else {
			this.props.handleNotificationPreferencesSelected()
		}
	}

	helpSelection = () => this.props.navigateTo(
		navigationMenuContentTypes.HELP
	)

	handleLogoutSelected = () => this.props.handleLogoutSelected(
		this.props.userData.isImpersonateSession
	)

	FUNCTIONS = {
		[navigationMenuMainItemTypes.NOTIFICATION_PREFERENCES]:
			this.handleNotificationPreferencesSelected,
		[navigationMenuMainItemTypes.ACCOUNT]:
			this.props.handleAccountSelected,
		[navigationMenuMainItemTypes.UPGRADE]:
			this.props.handleNavigationMenuUpgradeSelected,
		[navigationMenuMainItemTypes.HELP]:
			this.helpSelection,
		[navigationMenuMainItemTypes.MANAGE]:
			this.props.handleManageSelected,
		[navigationMenuMainItemTypes.SETTINGS]:
			this.props.handleSettingsSelected,
	}

	onSelect = id => this.FUNCTIONS[id]()

	render() {
		return (
			<Fragment>
				<section styleName='user'>
					<div styleName='user-avatar'>
						<Avatar src={this.props.userData.image} />
						{ this.props.shouldShowProfileImageButton &&
							<button
								styleName='user-avatar-button'
								onClick={this.props.updateProfileImageSelected}
							>
								<Isvg styleName='user-avatar-button-icon' src={CameraIcon} cacheGetRequests={true} />
							</button>
						}
					</div>
					<h1 styleName='user-name'>{this.props.userData.name}</h1>
					<h2 styleName='user-email'>{this.props.userData.email}</h2>
				</section>
				<section>
					<NavigationMenuList
						items={this.items}
						onSelect={this.onSelect}
					/>
				</section>
				<section styleName='footer'>
					<div styleName={classNames({
						'footer-button': true,
						'footer-button--impersonated': this.props.userData.isImpersonateSession,
					})}>
						<BaseButton
							bgColor='border-blue'
							onClick={this.handleLogoutSelected}
						>
							{localize(this.props.userData.isImpersonateSession ? 'navigationMenu_endImpersonate' : 'global_logOut')}
						</BaseButton>
					</div>
				</section>
			</Fragment>
		)
	}
}

NavigationMenuMain.propTypes = {
	navigateTo: PropTypes.func,
	handleAccountSelected: PropTypes.func.isRequired,
	userBadge: PropTypes.string,
	handleLogoutSelected: PropTypes.func.isRequired,
	handleNavigationMenuUpgradeSelected: PropTypes.func,
	shouldShowUpgradeButton: PropTypes.bool,
	userData: PropTypes.shape({
		name: PropTypes.string,
		email: PropTypes.string,
		image: PropTypes.string,
		isImpersonateSession: PropTypes.bool,
	}),
	updateProfileImageSelected: PropTypes.func.isRequired,
	shouldShowManageButton: PropTypes.bool,
	handleManageSelected: PropTypes.func,
	shouldShowProfileImageButton: PropTypes.bool,
	handleSettingsSelected: PropTypes.func.isRequired,
	shouldShowNotificationPreferencesView: PropTypes.bool,
	handleNotificationPreferencesSelected: PropTypes.func.isRequired,
}

NavigationMenuMain.defaultProps = {
	navigateTo: () => {},
	handleNavigationMenuUpgradeSelected: () => {},
	shouldShowUpgradeButton: false,
	userData: {
		name: '',
		email: '',
		image: '',
		isImpersonateSession: false,
	},
	shouldShowManageButton: false,
	shouldShowProfileImageButton: true,
	shouldShowNotificationPreferencesView: false,
}

export default CSSModules(NavigationMenuMain, styles, {allowMultiple: true})
